import React, { useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import renderComponent from '../utils/node'


const Notification = (props) => {

    const { type, message, onClose, onOpen } = props;

    const [visible, setVisible] = useState(true);

    const handleClose = (_, reason) => {
        reason = reason || 0;

        if (reason === "clickaway") {
            return;
        }

        onClose && onClose(); 

        setVisible(false)
    };

    const handleOpen = () => {
        onOpen && onOpen();
    }

    return (
        <Snackbar
            open={visible}
            autoHideDuration={5000}
            onEntered={handleOpen}
            onClose={handleClose}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right"
            }}
            sx={{
                backgroundColor: 'white',
                borderRadius: '10px'
            }}
        >
            <Alert
                onClose={handleClose}
                elevation={1}
                variant="standart"
                severity={type}
                color={type}
                sx={{
                    fontWeight: '900',
                    fontSize: '15px',
                    borderRadius: '10px'
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    )
}

Notification.success = (props) => renderComponent(
    "notification",
    <Notification type="success" {...props} />
)

Notification.error = (props) => renderComponent(
    "notification",
    <Notification type="error" {...props} />
)

Notification.warning = (props) => renderComponent(
    "notification",
    <Notification type="warning" {...props} />
)

Notification.info = (props) => renderComponent(
    "notification",
    <Notification type="info" {...props} />
)

export default Notification;